import { z } from 'zod';

export const premiumShiftSchema = z
  .object({
    allowPremiumShifts: z.boolean().nullable().optional(),
    premiumShiftOffsetMode: z.string().nullable().optional(),
    premiumShiftFixedOffset: z.number().nullable().optional(),
    premiumShiftMultiplierCode: z.string().nullable().optional(),
  })
  .passthrough()
  .superRefine((data, ctx) => {
    if (!data.allowPremiumShifts) return;

    if (!data.premiumShiftOffsetMode) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['premiumShiftOffsetMode'],
        message: 'Please select a premium shift type',
      });
    } else {
      switch (data.premiumShiftOffsetMode) {
        case 'fixed':
          if (data.premiumShiftFixedOffset == null || data.premiumShiftFixedOffset <= 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['premiumShiftFixedOffset'],
              message: 'Fixed rate premium must be greater than 0',
            });
          }
          break;
        case 'multiplier_offset':
        case 'fixed_offset':
          if (!data.premiumShiftMultiplierCode) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: ['premiumShiftMultiplierCode'],
              message: 'Please select a rate multiplier for premium shifts',
            });
          }
          break;
      }
    }
  });

export type PremiumShiftSchemaData = z.infer<typeof premiumShiftSchema>;
